// extracted by mini-css-extract-plugin
module.exports = {"button":"BuyButton_button_pb1E8","spin":"BuyButton_spin_2Gazg"};